
export default {
  //  BASE_API_URL : 'https://microservices.crmpaisa.com/api/v1/',
  //  BASE_API_URL : 'https://microservices.sfscrm.in/api/v1/',
  // BASE_API_URL: 'http://localhost/lms/api', 
  BASE_API_URL: 'https://lms.snaprupee.in/api',

  // loan:{
  //   LOGIN:'customer-journey/login',
  //   OTP_VERIFY:"customer-journey/otp-verify", 
  //   RESEND_OTP:"customer-journey/resend-otp",
  //   CUSTOMER_DETAILS: "lead-service/get-customer-details",
  //   PAN_VERIFICATION:"customer-journey/verify-pan",
  //   ELIGIBILITY_CHECK:"customer-journey/check-eligibility",
  //   LOAN_QUOTE:"lead-service/loan-quote-decision",
  //   LOAN_GENERATE:"lead-service/generate-loan-quote",
  //   DETAILS_PERSONAL:"customer-journey/update-personal-details",
  //   EMPLOYMENT_DETAILS:"customer-journey/update-employment-details",
  //   UPLOAD_DOCS:"lead-service/pay-slip-upload",
  //   BANK_VERIFY:"lead-service/bank-account-verification",
  //   LEAD_LIST:"lead-service/get-status-lead-list",
  //   LEAD_DETAIL:"lead-service/get-lead-view-detail",
  // }


  loan: {
    SEND_OTP: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    OTP_VERIFY: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    GET_DASHBOARD: "/Api/Website/RepeatInstantJourneyController/getDashboardData",
    PAN_VERIFICATION: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    CUSTOMER_DETAILS: "/Api/Website/RepeatInstantJourneyController/getCustomerDetails",
    PERSONAL_DETAILS: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    INCOME_DETAILS: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    ADDRESS_DETAILS: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    UPLOAD_DOCS: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",
    STATE_CITY_PINCODE: "/Api/MasterController/masterAPI",
    UPLOAD_PROFILE_PIC: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    PROFILE_PIC: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    ELIGIBILITY_CHECK: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    ABOUT_COMPANY: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",
    CALCULATE_LOAN: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",
    USER_DATA: "/Api/Website/getUser",
    ALL_LEADS: "/Api/Website/RepeatInstantJourneyController/getLeadList",
    LOAN_DETAIL: "/Api/Website/RepeatInstantJourneyController/getLeadDetail",
    LOAN_QUOTE: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",//LOAN_GENERATE
    LOAN_GENERATE: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",//LOAN_GENERATE
    GENERATE_ORDER_ID: "/Api/Website/RepeatInstantJourneyController/generateRazorpayorderId",
    MANDATORY_DOCS: "/Api/Website/RepeatInstantJourneyController/check_customer_mandatory_documents",
    ALL_BLOGS: "/Api/Website/BlogsController/blog",
    BLOG_DETAILS: "/Api/Website/BlogsController/blogDetail",
    GET_CAPTCHA: "/index.php/Api/EnquiryController/generate_captcha",
    ENQUIRY: "/Api/EnquiryController/enquire",
    EKYC_INITIATE: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",
    ACCOUNT_AGGREGATOR: "/Api/Website/RepeatInstantJourneyController/saveleadDetails",
    REDIRECT: "/Api/Website/RepeatInstantJourneyController/getJourneyRedirectionData",
    selfie_upload: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
    resend_otp: "/Api/Website/RepeatInstantJourneyController/appCustomerRegisteration",
  }
}
